"use client";

import React from "react";
import { Grid } from "semantic-ui-react";

/**
 * Client-safe wrapper for Semantic UI Grid component.
 * Allows Grid usage in Server Components by importing this shim.
 */
export function GridShim({ children, ...props }) {
  return <Grid {...props}>{children}</Grid>;
}

export function GridRowShim({ children, ...props }) {
  return <Grid.Row {...props}>{children}</Grid.Row>;
}

export function GridColumnShim({ children, ...props }) {
  return <Grid.Column {...props}>{children}</Grid.Column>;
}
